import { render } from "./Group.vue?vue&type=template&id=4b944394&scoped=true&ts=true"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"

import "./Group.vue?vue&type=style&index=0&id=4b944394&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b944394"]])

export default __exports__